import { Paperclip } from 'lucide-react'
import React, { useState, useRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Button } from '@/components/ui/button'

const SingleFileUpload = ({
  label = 'Upload a file',
  helpText,
  onChange,
  theme = 'primary',
  tabIndex,
  className,
  error,
  ...props
}) => {
  const [file, setFile] = useState(null)
  const inputRef = useRef(null)
  const hasError = !!error

  const handleFileUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0])
    }
  }

  const handleLabelClick = () => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  return (
    <div className={twMerge('flex flex-col items-start', className)}>
      <Button
        onClick={handleLabelClick}
        tabIndex={tabIndex}
      >
        <Paperclip className="h-4 w-4 inline-block mr-2" />
        {label}
      </Button>

      <If condition={helpText}>
        <small className="mt-2">{helpText}</small>
      </If>

      <If condition={hasError}>
        <small className="mt-1 text-red-500 font-semibold">{error}</small>
      </If>

      <input
        ref={inputRef}
        id="upload-button"
        type="file"
        className="sr-only"
        onChange={e => {
          handleFileUpload(e)
          if (onChange) onChange(e)
        }}
        aria-invalid={hasError}
        {...props}
      />
    </div>
  )
}

export default SingleFileUpload
